import axios from 'axios'
import _ from 'lodash'
import moment from 'moment'
import { URL } from '../../../env'

export default {
  data: () => ({
    syndication_id: localStorage.getItem('syndication_id'),
    status: true,
    payout_wrt_paydates_total: 0,
    tableData: { page: 1, length: 25 },
    tableDataPayDates: { page: 1, length: 25 },
    loadingSpin: false,
    processBar: false,
    processBarPayDates: false,
    payout_wrt_paydates: [],
    payout_pay_paydates: { data: [] },
    selectedPayDate: null,
  }),
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      this.processBarPayDates = true
      this.processBar = true
      await axios
        .get(`${URL}/api/payouts/get_payouts_paydates/${this.syndication_id}`, { params: this.tableDataPayDates })
        .then(res => {
          this.payout_pay_paydates = res.data
          this.processBarPayDates = false
        })
        .catch(() => {
          this.processBarPayDates = false
        })
      if (this.payout_pay_paydates.data.length > 0) {
        this.getPayoutsWRTPayDates(this.payout_pay_paydates.data[0])
      } else {
        this.processBar = false
      }
    },
    async loadMorePaydates() {
      if (this.tableDataPayDates.page < this.payout_pay_paydates.last_page) {
        this.processBarPayDates = true
        this.tableDataPayDates.page = this.tableDataPayDates.page + 1
        await axios
          .get(`${URL}/api/payouts/get_payouts_paydates/${this.syndication_id}`, { params: this.tableDataPayDates })
          .then(res => {
            let data = res.data.data
            delete res.data.data
            this.payout_pay_paydates = Object.assign(this.payout_pay_paydates, res.data)
            this.payout_pay_paydates.data = _.orderBy(_.concat(this.payout_pay_paydates.data, data), o => new moment(o.pay_date), ['desc'])
            this.processBarPayDates = false
          })
          .catch(() => {
            this.processBarPayDates = false
          })
      }
    },
    async getPayoutsWRTPayDates(item) {
      this.payout_wrt_paydates = []
      this.status = false
      this.selectedPayDate = item.pay_date
      this.processBar = true
      this.tableData = Object.assign(this.tableData, { syndication_id: item.syndication_id, pay_date: item.pay_date, page: 1 })
      await axios
        .get(`${URL}/api/payouts/get_payouts_wrt_paydate`, { params: this.tableData })
        .then(res => {
          this.processBar = false
          this.payout_wrt_paydates = res.data.data
          this.payout_wrt_paydates_total = res.data.total
          this.status = true
        })
        .catch(() => {
          this.processBar = false
        })
    },
    async loadMore() {
      if (this.payout_wrt_paydates.length < this.payout_wrt_paydates_total) {
        this.loadingSpin = true
        this.tableData.page = this.tableData.page + 1
        await axios.get(`${URL}/api/payouts/get_payouts_wrt_paydate`, { params: this.tableData }).then(res => {
          this.payout_wrt_paydates = _.concat(this.payout_wrt_paydates, res.data.data)
          this.loadingSpin = false
        })
      }
    },
    exportPayoutSheet({ pay_date, syndication_id }) {
      axios({
        url: `${URL}/api/payouts/export_syndicated_payouts`,
        method: 'POST',
        responseType: 'blob',
        data: { syndication_id, pay_date },
      }).then(response => {
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(new Blob([response.data]))
        link.setAttribute('download', 'payout_(' + pay_date + ').xlsx')
        document.body.appendChild(link)
        link.click()
      })
    },
    atBottom({ target }) {
      return target.scrollTop + target.clientHeight + 5 >= target.scrollHeight
    },
    onPayDatesScroll(e) {
      if (this.atBottom(e)) this.loadMorePaydates()
    },
    onTableScroll(e) {
      if (this.atBottom(e) && this.status) this.loadMore()
    },
  },
}
